/**
 * WeatherIconColors - Maps Ionicons weather icon names to themed colors.
 */

const ICON_COLOR_MAP: Record<string, string> = {
  'sunny-outline': '#F59E0B',           // Amber/yellow for sun
  'partly-sunny-outline': '#F59E0B',    // Amber/yellow for partial sun
  'cloudy-outline': '#9CA3AF',          // Gray for overcast
  'rainy-outline': '#3B82F6',           // Blue for rain
  'snow-outline': '#93C5FD',            // Light blue for snow
  'thunderstorm-outline': '#7C3AED',    // Purple for thunderstorm
  'cloud-outline': '#9CA3AF',           // Gray default
};

const DEFAULT_COLOR = '#9CA3AF';

export function getWeatherIconColor(iconName: string): string {
  return ICON_COLOR_MAP[iconName] ?? DEFAULT_COLOR;
}
